/**
 * GiftTiers — effective cart value for gift thresholds.
 * On the cart page, use the same payable total shown on "Pagar pedido" (live DOM).
 */
(function (global) {
  "use strict";

  function readGiftFlag(props) {
    if (!props) return false;
    var v = props._is_gift || props.is_gift;
    return v === true || v === "true" || v === "1" || v === 1;
  }

  function parsePercent(raw) {
    var n = Number(raw);
    if (!Number.isFinite(n) || n <= 0 || n >= 100) return 0;
    return n;
  }

  function parseMoneyToMajor(text) {
    if (text == null) return NaN;
    var s = String(text).replace(/[^\d.,-]/g, "");
    if (!s) return NaN;

    var lastComma = s.lastIndexOf(",");
    var lastDot = s.lastIndexOf(".");
    if (lastComma > -1 && lastDot > -1) {
      if (lastComma > lastDot) s = s.replace(/\./g, "").replace(",", ".");
      else s = s.replace(/,/g, "");
    } else if (lastComma > -1) {
      var afterComma = s.length - lastComma - 1;
      if (afterComma <= 2) s = s.replace(",", ".");
      else s = s.replace(/,/g, "");
    } else if (lastDot > -1) {
      var afterDot = s.length - lastDot - 1;
      if (afterDot > 2) s = s.replace(/\./g, "");
    }

    var n = Number(s);
    return Number.isFinite(n) ? n : NaN;
  }

  /** Payable total from checkout CTA, e.g. "PAGAR PEDIDO • 986.58€ 1,409.40€" */
  function payableTotalFromCheckoutButton() {
    if (typeof document === "undefined") return NaN;
    var btn =
      document.querySelector("#Cart button[name='checkout']") ||
      document.querySelector("button.checkout-button[name='checkout']") ||
      document.querySelector(".proceed-to-checkout button[name='checkout']") ||
      document.querySelector("[name='checkout']");
    if (!btn) return NaN;

    var text = (btn.textContent || "").trim();
    if (!text) return NaN;

    var amounts = [];
    var re = /(\d[\d.,]*)\s*(?:€|EUR)?/gi;
    var m;
    while ((m = re.exec(text)) !== null) {
      var major = parseMoneyToMajor(m[1]);
      if (Number.isFinite(major) && major > 0) amounts.push(major);
    }

    if (!amounts.length) return NaN;
    if (amounts.length >= 2) return Math.min.apply(null, amounts);
    return amounts[0];
  }

  function percentFromTags(tags) {
    if (!Array.isArray(tags)) return 0;
    for (var i = 0; i < tags.length; i++) {
      var t = String(tags[i] || "").trim();
      var nTag = t.match(/^N(\d{1,2})$/i);
      if (nTag) {
        var fromN = parsePercent(nTag[1]);
        if (fromN) return fromN;
      }
    }
    return 0;
  }

  function percentFromDiscountGroup(group) {
    if (group == null || group === "") return 0;
    var s = String(group).trim();
    var numeric = parsePercent(s);
    if (numeric) return numeric;
    var m = s.match(/(?:dto|descuento|discount)?[_:\s-]*(\d{1,2})\s*%?/i);
    return m ? parsePercent(m[1]) : 0;
  }

  function getB2bDiscountPercent(ctx) {
    ctx = ctx || global.GiftTierContext || {};
    var fromCtx = parsePercent(ctx.b2bDiscountPercent);
    if (fromCtx) return fromCtx;
    var fromGroup = percentFromDiscountGroup(ctx.b2bDiscountGroup);
    if (fromGroup) return fromGroup;
    var fromTags = percentFromTags(ctx.customerTags);
    if (fromTags) return fromTags;

    var btn = payableTotalFromCheckoutButton();
    if (!Number.isFinite(btn)) return 0;
    var text = "";
    var el =
      document.querySelector("#Cart button[name='checkout']") ||
      document.querySelector("[name='checkout']");
    if (el) text = el.textContent || "";
    var amounts = [];
    var re = /(\d[\d.,]*)\s*(?:€|EUR)?/gi;
    var m;
    while ((m = re.exec(text)) !== null) {
      var major = parseMoneyToMajor(m[1]);
      if (Number.isFinite(major) && major > 0) amounts.push(major);
    }
    if (amounts.length >= 2) {
      var hi = Math.max.apply(null, amounts);
      var lo = Math.min.apply(null, amounts);
      if (hi > lo) return parsePercent(Math.round((1 - lo / hi) * 100));
    }
    return 0;
  }

  function lineEffectiveCents(item) {
    var line = Number(item && item.line_price);
    var final = Number(item && item.final_line_price);
    if (!Number.isFinite(line) || line < 0) line = 0;
    if (Number.isFinite(final) && final >= 0 && final < line) return final;
    return line;
  }

  /**
   * @param {object} cart - /cart.js payload
   * @returns {number} cart value in major currency (EUR)
   */
  function regularCartValue(cart, opts) {
    opts = opts || {};
    var isGiftFn = opts.isGift || readGiftFlag;

    var fromCheckout = payableTotalFromCheckoutButton();
    if (Number.isFinite(fromCheckout) && fromCheckout > 0) {
      return fromCheckout;
    }

    var cents = 0;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (isGiftFn(item.properties)) continue;
      cents += lineEffectiveCents(item);
    }

    var pct = getB2bDiscountPercent(opts.context);
    if (pct > 0) cents = Math.round(cents * (1 - pct / 100));

    return cents / 100;
  }

  global.GiftTiersCartValue = {
    readGiftFlag: readGiftFlag,
    getB2bDiscountPercent: getB2bDiscountPercent,
    lineEffectiveCents: lineEffectiveCents,
    regularCartValue: regularCartValue,
    payableTotalFromCheckoutButton: payableTotalFromCheckoutButton,
  };
})(typeof window !== "undefined" ? window : globalThis);
